module.exports = __webpack_public_path__ + "static/media/Savage_Main.5b190f08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Savage_Main.jpg
// module id = 352
// module chunks = 0